import RedeemDealModal from './RedeemDealModal';
export default RedeemDealModal;